import React, { FC, useEffect, useState } from 'react';
import { Select, Typography } from 'antd';
import { getAnalysisTypes } from '../../api/speechToInsightsApi';
import { AnalysisType } from '../../types/AnalysisType';

const { Option } = Select;

interface ListeningTypeSelectorProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export const ListeningTypeSelector: FC<ListeningTypeSelectorProps> = ({ value, onChange, disabled }) => {
    const [analysisTypes, setAnalysisTypes] = useState<AnalysisType[]>([]);

    useEffect(() => {
        const loadAnalysisTypes = async () => {
            try {
                const types = await getAnalysisTypes();
                setAnalysisTypes(types);
                if (types.length > 0 && !value) {
                    onChange(types[0].code);
                }
            } catch (error) {
                console.error('Error loading analysis types:', error);
            }
        };

        loadAnalysisTypes();
    }, []);

    return (
        <>
            <div style={{ marginBottom: '16px' }}>
                <Typography.Text strong>Tipo de escucha:</Typography.Text>
            </div>
            <Select
                value={value}
                onChange={onChange}
                style={{ width: '100%', marginBottom: '16px' }}
                disabled={disabled}
            >
                {analysisTypes.map(type => (
                    <Option key={type.code} value={type.code}>
                        {type.nameEs}
                    </Option>
                ))}
            </Select>
        </>
    );
};